import * as Types from '@/store/mutation-types'
import Toast from '@/lib/toast'
import storage from '@/lib/storage'
import store from '@/store'
import router from '@/router'
import i18n from '@/lib/i18n'
import connectAuthClient from '@/lib/connect-client/connect-auth-client'
import RtkSettingInfo from '@/lib/caster/rtk_setting_info'
import RtkBase from '@/lib/caster/rtk_base'
import RtkRover from '@/lib/caster/rtk_rover'
import UserInfo from '@/lib/user-info'

const state = {}
const getters = {}
const mutations = {}
const actions = {
  // サインアップ
  authSimpleSignUpAndSignIn({ commit }, request) {
    commit(Types.SIMPLE_SIGN_UP_STARTED)
    connectAuthClient
      .simpleSignUpAndSignIn(request)
      .then(response => {
        const rememberMe = true
        actions._authLoginInitProcess(commit, rememberMe, response.data, request.nextRoute)
      })
      .catch(error => {
        console.error(error)
        if (error.response.status === 406) {
          Toast.i18nError('customSimpleSignUpAndSignInError')
        } else {
          Toast.i18nError('customSimpleSignUpServerError')
        }
      })
      .finally(() => {
        request.onSignUpSuccessHandler()
        commit(Types.SIMPLE_SIGN_UP_FINISHED)
      })
  },

  // パスワードログイン
  authLogin({ commit }, loginInfo) {
    commit(Types.LOGIN_STARTED)
    const credentials = loginInfo.credentials
    connectAuthClient
      .login(credentials)
      .then(response => {
        // RememberMe保存
        const rememberMe = credentials.rememberMe
        actions._authLoginInitProcess(commit, rememberMe, response.data, loginInfo.nextRoute)
      })
      .catch(error => {
        commit(Types.LOGIN_FAILURE)
        console.error(error)
        if (error.response) {
          const message = error.response.data.message
          Toast.error(message)
        } else {
          Toast.error('Login failed.')
        }
      })
  },

  authChangePassword({ commit }, changePasswordInfo) {
    const currentPassword = changePasswordInfo.currentPassword
    const newPassword = changePasswordInfo.newPassword
    connectAuthClient
      .changePassword(currentPassword, newPassword)
      .then(response => {
        router.replace({ name: 'UserPasswordSuccess' })
      })
      .catch(error => {
        if (error.response) {
          const message = error.response.data.message
          Toast.error(message)
        } else {
          Toast.error('change password failed.')
        }
      })
  },

  authCreatePassword({ commit }, createPasswordInfo) {
    const newPassword = createPasswordInfo.newPassword
    connectAuthClient
      .createPassword(newPassword)
      .then(response => {
        commit(Types.PASSWORD_ENTERED, true)
        router.replace({ name: 'UserPasswordSuccess' })
      })
      .catch(error => {
        console.error(error)
        Toast.error('create password failed.')
      })
  },

  // OAuthログイン
  authOAuthLogin({ commit }, request) {
    commit(Types.SIMPLE_SIGN_UP_STARTED)
    connectAuthClient
      .oAuthLogin(request)
      .then(response => {
        request.onSignUpSuccessHandler()
        const rememberMe = true
        actions._authLoginInitProcess(commit, rememberMe, response.data, request.nextRoute)
      })
      .catch(error => {
        console.error(error)
        Toast.i18nError('customOAuthServerError')
        commit(Types.SIMPLE_SIGN_UP_FINISHED)
        router.push({ name: 'Login' })
      })
  },

  // リフレッシュトークン取得成功時の処理
  authRefreshTokenSuccess({ commit }, tokenResponse) {
    return actions._authHandleTokenResponse(commit, null, tokenResponse, false, null)
  },

  // 自分自身の情報取得
  authGetMe({ commit }, params = {}) {
    connectAuthClient.getMe().then(response => {
      const userInfo = response.data
      storage.saveUserInfo(userInfo)
      commit(Types.SET_USER_INFO, userInfo)
      // FIXME purchaseInfoをpayサーバーからとってくるようにする
      store.dispatch('getPurchaseInfo', params)
      // getPurchaseInfoでonSuccessを実行
    })
  },

  // Cognitoのグループ情報取得
  authGetUserGroupsInfo({ commit }) {
    connectAuthClient
      .getUserGroupsInfo()
      .then(response => {
        commit(Types.SET_USER_GROUPS_INFO, response.data)
      })
      .catch(error => {
        console.error(error)
      })
  },

  // ユーザー情報更新
  authUpdateUser({ commit }, userData) {
    // Invoke API
    connectAuthClient
      .updateUser(userData)
      .then(response => {
        const userInfo = response.data
        storage.saveUserInfo(userInfo)
        commit(Types.SET_USER_INFO, userInfo)
        // store.dispatch('setPurchaseInfoFromUserInfo', userInfo)
        Toast.i18nSuccess('customSaveSuccess')
        // FIXME Freeの時はdatastoreにアクセスさせたくないので違うところで行う
        // store.dispatch('listOperationAvailableTypes')
      })
      .catch(error => {
        console.error(error)
      })
  },

  // ユーザーアイコン更新
  authUpdateUserIcon({ commit }, params) {
    connectAuthClient.updateUserIcon(params).then(response => {
      store.dispatch('authGetMe')
      Toast.i18nSuccess('customUpdatedIconMessage')
    })
  },

  // なりすましユーザー昇格（要管理者権限）
  authImpersonate({ commit }, targetUserEmail) {
    connectAuthClient
      .impersonate(targetUserEmail)
      .then(response => {
        actions._authHandleTokenResponse(commit, false, response.data, true, null)
        store.dispatch('initFields2')
        store.dispatch('listOperationAvailableTypes')
        // store.dispatch('fetchSubscriptionInfo')
        router.push({ name: 'Feed' })
      })
      .catch(error => {
        console.error(error)
        if (error.response) {
          const message = error.response.data.message
          Toast.error(message)
        } else {
          Toast.error('Switch User failed.')
        }
      })
  },

  // caster関連
  authGetRtkSettingInfo({ commit }) {
    connectAuthClient.getRtkSettingInfo().then(response => {
      if (response.data) {
        const info = RtkSettingInfo.fromApi(response.data)
        commit(Types.SET_RTK_SETTING_INFO, info)
      }
    })
  },

  // caster関連
  authListCasterBasesAndRovers({ commit }) {
    connectAuthClient.listCurrentCasterBaseAndClient().then(response => {
      const responseData = response.data.data
      if (responseData) {
        let items = responseData.ServersByOwner.items
        let bases = []
        for (let i = 0; i < items.length; i++) {
          const rtkBase = RtkBase.fromApi(items[i])
          bases.push(rtkBase)
        }
        commit(Types.SET_RTK_BASES, bases)

        items = responseData.ClientsByOwner.items
        let rovers = []
        for (let i = 0; i < items.length; i++) {
          const rtkBase = RtkRover.fromApi(items[i])
          rovers.push(rtkBase)
        }
        commit(Types.SET_RTK_ROVERS, rovers)
      }
    })
  },

  // トークンを取得し直す（プラン変更時）
  authRefreshToken({ commit }, params) {
    connectAuthClient
      .refreshAccessToken()
      .then(response => {
        actions._authSetToken(commit, null, response.data)
        // リフレッシュトークンデーモン起動
        connectAuthClient.startRefreshTokenDaemon()
        if (params.onSuccess) {
          params.onSuccess()
        }
      })
      .catch(error => {
        console.error(error)
      })
  },

  _authLoginInitProcess(commit, rememberMe, tokenResponse, nextRoute) {
    storage.saveRememberMe(rememberMe)

    actions._authHandleTokenResponse(commit, rememberMe, tokenResponse, false, nextRoute)

    // FIXME 後方互換性
    // let isPayer = false
    // try {
    //   isPayer = tokenResponse.userInfo.isPayer
    // } catch (ignore) {
    //   // console.error(ignore)
    // }
    // if (!isPayer && nextRoute !== '/sso/shopify') {
    //   store.dispatch('initFields2', {
    //     fieldEmptyAction: Constants.INIT_FIELD_OPTION_SHOW_FIELD_IMPORT,
    //   })
    // }
  },

  _authSetToken(commit, rememberMe, tokenResponse) {
    // リフレッシュトークン保存
    const refreshToken = tokenResponse.refreshToken
    const refreshTokenExpiredAt = tokenResponse.refreshTokenExpiredAt
    storage.saveRefreshTokens(refreshToken, refreshTokenExpiredAt)

    // アクセストークン
    const accessToken = tokenResponse.accessToken
    const accessTokenExpiredAt = tokenResponse.accessTokenExpiredAt

    // アクセストークン保存
    // getMe完了前に画面がmountされてもloginUsername等を参照できるよう、storageのuserInfoを先行セットする
    let userInfo = storage.getUserInfo() || null
    const loginInfo = { rememberMe, userInfo, accessToken, accessTokenExpiredAt }
    commit(Types.LOGIN_SUCCESS, loginInfo)
  },

  _authHandleTokenResponse(commit, rememberMe, tokenResponse, impersonating = false, nextRoute) {
    const originalUserInfo = storage.getUserInfo()
    actions._authSetToken(commit, rememberMe, tokenResponse)

    // getMeしてUserInfoを取得 (Promiseを返し、呼び出し側で完了を待てるようにする)
    return connectAuthClient.getMe().then(response => {
      let userInfo = response.data

      // impersonatingの場合は、impersonatingUsernameをセットする
      if (impersonating) {
        userInfo.impersonatingUsername = originalUserInfo.username
        userInfo.impersonatingNickname = originalUserInfo.nickname
      }

      storage.saveUserInfo(userInfo)
      commit(Types.SET_USER_INFO, userInfo)

      // 表示単位系
      const systemOfUnits = userInfo.systemOfUnits
      commit(Types.SET_SYSTEM_OF_UNITS, systemOfUnits)

      // Langの設定 --> Langはstorageに保管することにする
      i18n.setUserLang(userInfo)

      // // SubscriptionInfo
      // const subscriptionInfo = tokenResponse.subscriptionInfo
      // commit(Types.SET_SUBSCRIPTION_INFO, subscriptionInfo)

      // AWS Cred情報
      // const awsSession = tokenResponse.awsSession
      // if (awsSession) {
      //   commit(Types.SET_AWS_SESSION_INFO, awsSession)
      // }

      // Freeの場合はふような処理をしない
      if (!UserInfo.hasFreeFunctionality()) {
        // Fields
        if (store.getters.fields.length == 0) {
          store.dispatch('initFields2')
        }

        // そのユーザーの全圃場重心
        store.dispatch('getCentroidOfUserFields')

        // AvailableOperationTypesも取得しておく
        store.dispatch('listOperationAvailableTypes')

        // store.dispatch('fetchSubscriptionInfo')

        // デバイス関連
        // store.dispatch('listDevices')

        // WebMarker関連
        // store.dispatch('listWebMarkers')

        // // ユーザのパスワード作成情報取得
        // store.dispatch('authPasswordEntered')

        // フォローリクエスト情報を取得
        // store.dispatch('listIncomingSubscriptionRequests')

        // ユーザーグループ情報(EAPテスターなどのグループ)
        store.dispatch('authGetUserGroupsInfo')

        // Grow関連
        store.dispatch('listPfObservations')
        store.dispatch('listAtObservations')

        // Caster関連
        store.dispatch('authListCasterBasesAndRovers')

      }

      // StripeInfo
      store.dispatch('getStripeInfo')

      // PurchaseInfo
      store.dispatch('getPurchaseInfo')

      // BillingPlans
      store.dispatch('listBillingPlans')

      // リフレッシュトークンデーモン起動
      connectAuthClient.startRefreshTokenDaemon()

      if (nextRoute) {
        // 購入情報からの制御
        const purchaseInfo = storage.getPurchaseInfo()
        if (purchaseInfo.isGoogleCanceled()) {
          nextRoute = '/free'
        }
        // フリーの場合はログイン直後は/freeへ
        if (UserInfo.hasFreeFunctionality()) {
          nextRoute = '/free'
        }
        router.push(nextRoute)
      }
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
